<template>
  <v-main>
    <v-row>
      <v-col class="text-center">
        <h4>En construccion</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <v-btn @click="$router.go(-1)">Volver</v-btn>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
export default {
  name: "ImportScopus"
};
</script>

<style scoped></style>
